module.exports = __webpack_public_path__ + "img/red-brick-bg.b1afd56f.png";